import { render, staticRenderFns } from "./member-vendors.vue?vue&type=template&id=0e8106a5&"
import script from "./member-vendors.vue?vue&type=script&lang=js&"
export * from "./member-vendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports